import classNames from 'classnames';
import React, { PropsWithChildren, ReactElement } from 'react';
import css from './SearchListResult.module.scss';
import { useLocalization } from '../../../context/Localization/localization';
import { SizedIconProps } from '../../Icon/SizedIcon/SizedIcon.types';
import { GMCheckbox } from '../../Checkbox';
import { GMTitle } from '../../Title';
import { GMGenericButton } from '../../ButtonBase';

export interface ISearchListResultProps {
    title: string;
    onClick: () => void;
    icon?: ReactElement<SizedIconProps>;
    checked?: boolean;
    notListed?: boolean;
    /** Disables the checkbox and prevents the result from being clicked */
    disabled?: boolean;
    headerLevel?: 4 | 5 | 6;
}

export const SearchListResult: React.FC<PropsWithChildren<ISearchListResultProps>> = React.memo((props) => {
    const onClick = () => {
        !props.disabled && props.onClick();
    };
    const Localization = useLocalization();

    return (
        <GMGenericButton
            onClick={onClick}
            title={props.notListed ? Localization.ClickToManuallyEnter : Localization.ClickToConfirmInformation}
            id={props.notListed ? Localization.ClickToManuallyEnter : Localization.ClickToConfirmInformation}
            ariaLabel={props.notListed ? Localization.ClickToManuallyEnter : Localization.ClickToConfirmInformation}
        >
            <div className={classNames(css.searchResult, { [css.notListed]: props.notListed })}>
                <div className={css.information}>
                    {props.icon ? <div className={css.icon}>{props.icon}</div> : null}
                    <div className={css.content}>
                        <GMTitle headerLevel={props.headerLevel ?? 4}>
                            {props.title}
                        </GMTitle>
                        <div>{props.children}</div>
                    </div>
                </div>
                <GMCheckbox
                    checked={props.checked}
                    disabled={props.disabled}
                    iconSize={'medium'}
                />
            </div>
        </GMGenericButton>
    );
});
